module.exports = __webpack_public_path__ + "f2553ef6b26514343d076db10dc98e9f.pdf";